import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { ManagerCompaniesEffects } from '@appStore/managers/effects/manager-companies.effects';
import { ManagerRolesEffects } from '@appStore/managers/effects/manager-roles.effects';
import { ManagerUserInvitationEffects } from '@appStore/managers/effects/manager-company-invitation.effects';
import { ManagerCustomersEffects } from '@appStore/managers/effects/manager-customers.effects';

export const effects: any[] = [
  ManagerCompaniesEffects,
  ManagerRolesEffects,
  ManagerUserInvitationEffects,
  ManagerCustomersEffects
];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class ManagersEffectsModule {}
